import {
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from "react";
import { useToggle } from "usehooks-ts";

type LegContextProps = {
  legIndex: number | null;
  setLegIndex: Dispatch<SetStateAction<number | null>>;
  isEast: boolean;
  toggleDirection: () => void;
  setDirection: Dispatch<SetStateAction<boolean>>;
};

const LegContext = createContext<LegContextProps>({
  legIndex: null,
  setLegIndex: () => {},
  isEast: true,
  toggleDirection: () => {},
  setDirection: () => {},
});

export const useLegContext = () => useContext(LegContext);

export const LegProvider = ({ children }: PropsWithChildren) => {
  const [legIndex, setLegIndex] = useState<number | null>(null);
  const [isEast, toggleDirection, setDirection] = useToggle(true);
  return (
    <LegContext.Provider
      value={{ legIndex, setLegIndex, isEast, toggleDirection, setDirection }}
    >
      {children}
    </LegContext.Provider>
  );
};
